import { useState } from "react";
//@ts-ignore
import style from "../style/Login.module.css";

//@ts-ignore
import { SelectInput } from "@viuti/recursos";
import { LogoAppVertical } from "../../../models/Icons";

const BusinessSelectView = ({ businessList, setLoginForm, loginForm }) => {
  const arrayBusiness = businessList.map((n) => n.businessName.toUpperCase());
  const [business, setBusiness] = useState<string>("");
  return (
    <article className={style.articleSelect}>
      <span className={style.header}>
        <img className={style.logo} src={LogoAppVertical} alt="Prikly" />
        <h1>Elige la empresa de tu preferencia.</h1>
      </span>
      <span className={style.slideRight}>
        <SelectInput
          NoOptionLabel="Tu empresa"
          width="13rem"
          items={arrayBusiness}
          handleChange={(e) => {
            // Save the value
            setBusiness(e.target.value.toUpperCase());

            // Save the id in the loginForm
            const businessId = businessList.find(
              (n) =>
                n.businessName.toUpperCase() === e.target.value.toUpperCase()
            ).businessId;
            setLoginForm({ ...loginForm, businessId: businessId });
          }}
          value={business}
        />
      </span>
    </article>
  );
};

export default BusinessSelectView;
